import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {PriceV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/price_v2.types';
import {createContext, useContext} from 'react';

type UpdateFunctionType = (product: Price | PriceV2 | undefined) => void;
const context = createContext<UpdateFunctionType | undefined>(undefined);

export const PushNotificationProvider = context.Provider;
export const useUpdateShowNotification = () => useContext(context);
